import { Grid, Paper } from '@mui/material';
import { useSnackbar } from 'notistack';
import { SubmitHandler } from 'react-hook-form';
import { useMutation, useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router';
import * as commonApi from '../../api/app/commonApi';
import * as api from '../../api/app/monitoredCounterApi';
import { AssetFullPathHeader } from '../../components/core/AssetFullPathHeader/AssetFullPathHeader';
import { Loader } from '../../components/core/Loader/Loader';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { useTranslation } from '../../contexts/translation';
import { AssetDetailTabValues, MonitoredPanelValues } from '../../types/app/asset.types';
import { MonitoredCounterInputs } from '../../types/app/monitoredCounter.types';
import { dictionary } from '../../utils/core/dictionary';
import { paths } from '../../utils/core/routes';
import { MonitoredCounterForm } from './MonitoredCounterForm';
import { useStyles } from './MonitoredCounterForm.styles';

export function MonitoredCounterCreate() {
  const { data: isUsedHydra } = useQuery<boolean>('useHydra', commonApi.useHydraDataService);
  const { t } = useTranslation();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { parentId } = useParams();
  const { mutate: mutateCreateMonitoredCounter } = useMutation(api.createMonitoredCounter);

  const handleOnSubmit: SubmitHandler<MonitoredCounterInputs> = (data: MonitoredCounterInputs) => {
    data.parentAssetId = Number(parentId);
    if (data.useMultipleWithHydraPartitioning === undefined)
      data.useMultipleWithHydraPartitioning = false;
    mutateCreateMonitoredCounter(
      { ...data },
      {
        onSuccess: () => {
          enqueueSnackbar(t('page.monitored-counter.item-created'), { variant: 'success' });
          navigate(`${paths.ASSETS_DETAIL}/${parentId}`, {
            state: {
              tabValue: AssetDetailTabValues.MONITORED_VALUES,
              panelValue: MonitoredPanelValues.MONITORED_COUNTER,
            },
          });
        },
        onError: (result: any) => {
          enqueueSnackbar(`${result}`, { variant: 'error' });
        },
      },
    );
  };

  if (isUsedHydra === undefined) return <Loader />;
  return (
    <>
      {/* <PageHeader title={t('page.monitored-counter.headline-create')} /> */}
      <AssetFullPathHeader
        finalTitle={dictionary.MONITORED_COUNTER_CREATE}
        parentId={Number(parentId)}
      />
      <PageContent>
        <Grid container spacing={1}>
          <Grid item xs={12} md={8} lg={4}>
            <Paper className={classes.paper}>
              <MonitoredCounterForm
                onSubmit={handleOnSubmit}
                isUsedHydra={isUsedHydra}
                onBack={() =>
                  navigate(`${paths.ASSETS_DETAIL}/${parentId}`, {
                    state: {
                      tabValue: AssetDetailTabValues.MONITORED_VALUES,
                      panelValue: MonitoredPanelValues.MONITORED_COUNTER,
                    },
                  })
                }
              />
            </Paper>
          </Grid>
        </Grid>
      </PageContent>
    </>
  );
}
